<div class="container"
    [ngClass]="{'status-2-warp':status$()==eReplyStatus.InProgress,'status-1-warp':status$()==eReplyStatus.NotStarted,'status-3-warp':status$()==eReplyStatus.Finished}">
    <div class="wrap-title">
        <div class="icon red">
            <img class="status1" src="/assets/images/data/not-answered-questionaire-data-icon.svg" />
            <img class="status2" src="/assets/images/data/not-send-data-icon.svg" />
            <img class="status3" src="/assets/images/data/answered-questionaire-data-icon.svg" />
        </div>
        <div class="title">
            <div translate class="first-line status1">answeredTheQuestion.haveNotAnsweredYet</div>
            <div translate class="first-line status2">answeredTheQuestion.haveNotSendYet</div>
            <div class="first-line status3" translate>answeredTheQuestion.answeredTheQuestionaire</div>
            <div class="second-line">{{recipientsCurrentStatus$()?.length}} <span class="status1 status2"
                    translate>answeredTheQuestion.notYet</span><span class="status3"
                    translate>answeredTheQuestion.answered</span> </div>

        </div>
    </div>
    <div class="table scroll" *ngIf="(recipientsCurrentStatus$()?.length??0)>0">
        <div class="table-row table-header">
            <div class="table-item flex2" translate>answeredTheQuestion.tableHeaders.name</div>
            <div class="table-item" translate>answeredTheQuestion.tableHeaders.filedIn</div>
            <div class="table-item" translate>answeredTheQuestion.tableHeaders.group</div>
            <div *ngIf="status$() === eReplyStatus.Finished" class="table-item flex-half"></div>
        </div>

        <div class="table-row" *ngFor="let recipient of recipientsCurrentStatus$()">
            <div class="table-item flex2">
                <div class="user">
                    <p *ngIf="recipient.user?.firstName?.charAt(0)">
                        {{recipient.user.firstName!.charAt(0).toUpperCase() }}</p>
                    <p *ngIf="recipient.user?.lastName?.charAt(0)">{{
                        recipient.user.lastName!.charAt(0).toUpperCase()}}</p>
                </div>
                <div>{{recipient.user.firstName}} {{recipient.user.lastName}}</div>
                <div class="mainAnswer">{{recipient.mainAnswer}}</div>
            </div>

            <div class="table-item"> {{recipient.dateAnswered | queDate}}</div>
            <div class="table-item">{{recipient.groupName}}</div>
            <div class="table-item flex-half status3">
                <que-recipients-status-menu
                    (changeStatusEvent)="changeStatus(recipient.id,recipient.user.firstName,recipient.user.lastName)"></que-recipients-status-menu>
            </div>
        </div>
    </div>
</div>